<template>
  <div class="authPage">
    <div class="authCard">
      <b-overlay
        :show="inLoad"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
        <div class="authHero">
          <div class="authHero-badge">
            <b-icon icon="shield-lock-fill" scale="1.5"></b-icon>
          </div>
          <div class="authHero-kicker">Espace client ITTEC P&M</div>
          <h1 class="authHero-title">Authentification</h1>
          <p class="authHero-subtitle">Connectez-vous pour accéder à vos demandes, devis, commandes et factures.</p>
        </div>

        <div class="authFormWrap">
          <div class="authFormGrid">
            <div class="authField">
              <label class="authLabel">Login ou email</label>
              <b-input-group size="lg" class="authInputGroup">
                <b-input-group-prepend is-text>
                  <b-icon icon="person-fill"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="text" v-model="loginFiled" placeholder="Login | email"></b-form-input>
              </b-input-group>
            </div>

            <div class="authField">
              <label class="authLabel">Mot de passe</label>
              <b-input-group size="lg" class="authInputGroup">
                <b-input-group-prepend is-text>
                  <b-icon icon="key-fill"></b-icon>
                </b-input-group-prepend>
                <b-form-input v-model="pwdFiled" type="password" placeholder="Mot de passe"></b-form-input>
              </b-input-group>
            </div>
          </div>

          <b-collapse id="collapse-4" v-model="loginError" class="authError">
            Erreur d'authentification, veuillez vérifier vos codes.
          </b-collapse>

          <div class="authActions">
            <base-button size="lg" :show="!inLoad" @click="login()" class="authLoginBtn">
              Login
            </base-button>
            <a href="/inscription" class="authSecondaryLink">Nouveau client ? Créer un compte</a>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {SuperAdminRouter, AgentRouter, ClientRouter} from "@/router/initRouter";
export default {
  components: {
  },
  props: {
    withCid: {
      type: Boolean,
      default: () => {
        return false;
      },
    }
  },
  data() {
    return {
      loginFiled: '',
      pwdFiled: '',
      loginError: false,
      inLoad : false,
      requireAuth : false,
    };
  },
  methods: {
    checkAndGo(){
      const admin = Vue.$cookies.get("user");
      if(admin) {
        this.addRouterAndGo(admin)
      } else {
        this.requireAuth = true;
      }
    },

    addRouterAndGo(admin) {
      console.log("CH ", admin)
      if(["ADMIN", "ROOT", "COMMERCIAL", "TECHNIQUE", "MAGASINIER"].includes(admin.type)) {
        this.$router.addRoute(SuperAdminRouter);
        this.$router.push('/superadmin')
        return
      }

      if(admin.type === "CLIENT") {
        this.$router.addRoute(ClientRouter);
        this.$router.push('/client')   
        return
      }
    },

    login(){
      let $onNext = (response) => {
        if(response.data.length === 0) {
          this.loginError = true;
          return;
        }
        Vue.$cookies.set('user',response.data[0]);
        setTimeout(()=> {
          this.inLoad = false;
          this.addRouterAndGo(response.data[0])
        }, 3000)
        
      };

      let $onError = (error) => {
        this.inLoad = false;
      };

      let $onComplete = () => {
        
      };

      this.inLoad = true;
      this.loginError = false;
      this.__.httpAction({
        methode: 'POST',
        route: '/auth',
        data: {login: this.loginFiled, pwd: this.pwdFiled},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
  },
  mounted() {
    //Vue.$cookies.remove("user")
    this.checkAndGo()
  }
};
</script>
<style scoped>
.authPage {
  min-height: calc(100vh - 190px);
  padding: 48px 16px 72px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.authCard {
  width: 100%;
  max-width: 860px;
  border-radius: 30px;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border: 1px solid #dce5f0;
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.authHero {
  position: relative;
  padding: 34px 36px 28px;
  text-align: center;
  background:
    linear-gradient(135deg, rgba(245, 157, 42, 0.16) 0%, rgba(245, 157, 42, 0.02) 36%, transparent 36%),
    linear-gradient(-35deg, rgba(245, 157, 42, 0.16) 0%, rgba(245, 157, 42, 0.02) 34%, transparent 34%),
    linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  border-bottom: 1px solid #e5ebf3;
}

.authHero-badge {
  width: 72px;
  height: 72px;
  margin: 0 auto 12px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  box-shadow: 0 16px 30px rgba(241, 133, 27, 0.26);
}

.authHero-kicker {
  color: #6d7b93;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
}

.authHero-title {
  margin: 0 0 8px;
  color: #1e2a44;
  font-size: 40px;
  line-height: 1.05;
}

.authHero-subtitle {
  margin: 0 auto;
  max-width: 560px;
  color: #61728f;
  font-size: 15px;
  line-height: 1.6;
}

.authFormWrap {
  padding: 28px 36px 36px;
}

.authFormGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.authField {
  padding: 18px;
  border-radius: 20px;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f7fb 100%);
  border: 1px solid #e4ebf3;
}

.authLabel {
  display: block;
  margin-bottom: 10px;
  color: #5f6f8b;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.authInputGroup :deep(.input-group-text) {
  border-radius: 14px 0 0 14px !important;
  background: #fff;
  border-color: #d8e1ec;
  color: #667892;
}

.authInputGroup :deep(.form-control) {
  min-height: 52px;
  border-radius: 0 14px 14px 0 !important;
  border-color: #d8e1ec;
  font-size: 15px;
}

.authError {
  margin-top: 18px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #fff4f4;
  border: 1px solid #f3c5c5;
  color: #d14343;
  text-align: center;
}

.authActions {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.authLoginBtn {
  min-width: 220px;
}

.authSecondaryLink {
  color: #f1851b;
  font-weight: 700;
  text-decoration: none;
}

.authSecondaryLink:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .authPage {
    padding: 22px 12px 56px;
  }

  .authCard {
    border-radius: 24px;
  }

  .authHero {
    padding: 26px 18px 22px;
  }

  .authHero-title {
    font-size: 30px;
  }

  .authFormWrap {
    padding: 20px 16px 24px;
  }

  .authFormGrid {
    grid-template-columns: 1fr;
  }
}
</style>
